import { factoryObserver } from '@maui-mf/splitio'
import env from '@maui-mf/env'

const authorizationKey = env.SPLITIO_AUTHORIZATION_KEY
const debug = env.SPLITIO_FACTORY_DEBUG === '1'

export const start = () => {
  if (authorizationKey) {
    console.debug(`starting splitio factory observer, debug mode: ${debug}`) // eslint-disable-line

    factoryObserver.init({
      core: {
        authorizationKey
      },
      urls: {
        sdk: 'https://featflgs-sdk.advantage.mandiant.com/api',
        events: 'https://featflgs-evt.advantage.mandiant.com/api',
        auth: 'https://featflgs-ath.advantage.mandiant.com/api',
        streaming: 'https://featflgs-str.advantage.mandiant.com',
        telemetry: 'https://featflgs-tel.advantage.mandiant.com/api',
      },
      debug
    })
  } else {
    console.warn('splitio authorization key missing, factory observer cannot be started')
  }
}

export const getFeatures = () => {
  let resolved = false

  return new Promise(resolve => {
    // TODO it'd be useful for this case if we could unsubscribe from the factory observer
    factoryObserver.subscribe(factory => {
      if (!factory || resolved) {
        return
      }

      resolved = true

      const client = factory.client()
      const manager = factory.manager()

      const treatments = client.getTreatments(manager.names())

      const features = {}
      for (const treatment in treatments) {
        features[treatment] = treatments[treatment] === 'on'
      }

      resolve(features)
    })
  })
}
